export default __webpack_public_path__ + "static/displacement-3b63338e8478305b16c9cd5d91509657.webp";